import { Loader } from "@/components/loader";
import { Box, Button, Grid, Typography } from "@mui/material";
import moment from "jalali-moment";
import { useCallback, useEffect, useState } from "react";
import { getActiveAreaId, getModulePatients } from "../../../../api/area";
import qarbalNot from "../../../../assets/image/qarbalNot.png";
import SearchInput from "../../../project/searchInput";
import TableQarbal from "../../table/tableQarbal";

export default function Qarbal() {
  const [receptedPatients, setReceptedPatients] = useState([]);
  const [unReceptedPatients, setUnReceptedPatients] = useState([]);
  const [moduleName, setModuleName] = useState();

  const [moduleId, setModuleId] = useState();
  useEffect(() => {
    setModuleId(window.location.search.split("?", 3)[1].split("?", 2)[0]);
  }, [window.location.search]);

  const [areaId, setAreaId] = useState();
  const [receptedPageable, setReceptedPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [unreceptedPageable, setUnReceptedPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [receptedTotalSize, setReceptedTotalSize] = useState();
  const [unreceptedTotalSize, setUnreceptedTotalSize] = useState();

  const [receptedLoading, setReceptedLoading] = useState(false);
  const [unreceptedLoading, setUnReceptedLoading] = useState(false);

  const [valueSearch, setValueSearch] = useState("");
  const [valueSearchBeforeReception, setValueSearchBeforeReception] =
    useState("");

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const [unReceptedLastFetch, setUnReceptedLastFetch] = useState();

  const fetchUnReceptedPatients = useCallback(
    (refetchTotalElements, clearSearch) => {
      if (
        unReceptedLastFetch !== undefined &&
        Date.now() - unReceptedLastFetch < 500
      )
        return;
      setUnReceptedLoading(true);
      const query = new URLSearchParams();
      query.append("justUnRecepted", true);
      query.append("pageIndex", unreceptedPageable.pageIndex);
      query.append("pageSize", unreceptedPageable.pageSize);
      if (
        !clearSearch &&
        valueSearchBeforeReception &&
        valueSearchBeforeReception.length > 1
      ) {
        query.append("search", valueSearchBeforeReception);
      }
      query.append(
        "needTotalElements",
        unreceptedTotalSize === undefined || refetchTotalElements,
      );

      getModulePatients(areaId, moduleId, `?${query.toString()}`)
        .then((res) => {
          if (res) {
            setUnReceptedLastFetch(Date.now());
            setUnReceptedPatients(res.patients);

            if (refetchTotalElements) {
              setUnReceptedPageable({
                pageIndex: 0,
                pageSize: 10,
              });
            }
            if (unreceptedTotalSize === undefined || refetchTotalElements)
              setUnreceptedTotalSize(res.totalElements);
          }
        })
        .catch(() => {})
        .finally(() => setUnReceptedLoading(false));
    },
    [areaId, moduleId, unreceptedPageable, valueSearchBeforeReception],
  );

  useEffect(() => {
    if (areaId && moduleId) {
      fetchUnReceptedPatients(false, false);
    }
  }, [areaId, moduleId, unreceptedPageable]);

  const [lastFetch, setLastFetch] = useState();

  const fetchReceptedPatients = useCallback(
    (refetchTotalElements, clearSearch) => {
      if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;
      setReceptedLoading(true);
      const query = new URLSearchParams();
      query.append("justRecepted", true);
      query.append("pageIndex", receptedPageable.pageIndex);
      query.append("pageSize", receptedPageable.pageSize);
      query.append(
        "needTotalElements",
        receptedTotalSize === undefined || refetchTotalElements,
      );
      if (!clearSearch && valueSearch && valueSearch.length > 1) {
        query.append("search", valueSearch);
      }

      getModulePatients(areaId, moduleId, `?${query.toString()}`)
        .then((res) => {
          if (res) {
            setLastFetch(Date.now());
            setReceptedPatients(res.patients);
            setModuleName(res.moduleName);
            if (receptedTotalSize === undefined || refetchTotalElements)
              setReceptedTotalSize(res.totalElements);
            if (refetchTotalElements) {
              setReceptedPageable({
                pageIndex: 0,
                pageSize: 10,
              });
            }
          }
        })
        .catch(() => {})
        .finally(() => setReceptedLoading(false));
    },
    [areaId, moduleId, receptedPageable, valueSearch],
  );

  useEffect(() => {
    if (areaId && moduleId) {
      fetchReceptedPatients(false, false);
    }
  }, [areaId, moduleId, receptedPageable]);

  const handlePatientClick = useCallback(
    (oldReceptionStatus, data) => {
      const now = moment();
      const jalaliNow = now.locale("fa").format("YYYY/MM/DD HH:mm");
      data.createdAt = jalaliNow;

      if (oldReceptionStatus) {
        setUnReceptedPatients([...unReceptedPatients, data]);
        setReceptedPatients(
          receptedPatients.filter((row) => row.id !== data.id),
        );
        setReceptedTotalSize(receptedTotalSize - 1);
        setUnreceptedTotalSize(unreceptedTotalSize + 1);
      } else {
        setUnReceptedPatients(
          unReceptedPatients.filter((row) => row.id !== data.id),
        );
        setReceptedPatients([data, ...receptedPatients]);
        setReceptedTotalSize(receptedTotalSize + 1);
        setUnreceptedTotalSize(unreceptedTotalSize - 1);
      }
    },
    [
      receptedPatients,
      receptedTotalSize,
      unReceptedPatients,
      unreceptedTotalSize,
    ],
  );
  const [receptedTimer, setReceptedTimer] = useState();

  useEffect(() => {
    // پاک کردن تایمر قبلی
    if (receptedTimer !== undefined) {
      clearTimeout(receptedTimer);
    }

    // ست کردن تایمر جدید فقط اگر حداقل ۲ کاراکتر تایپ شده باشد
    if (valueSearch.length >= 2) {
      const timer = setTimeout(() => {
        fetchReceptedPatients(true, false);
      }, 500);

      setReceptedTimer(timer);
    }

    // پاکسازی تایمر هنگام unmount یا تغییر searchTerm
    return () => {
      if (receptedTimer !== undefined) {
        clearTimeout(receptedTimer);
      }
    };
  }, [valueSearch]);

  const [unreceptedTimer, setUnReceptedTimer] = useState();

  useEffect(() => {
    if (unreceptedTimer !== undefined) {
      clearTimeout(unreceptedTimer);
    }

    if (valueSearchBeforeReception.length >= 2) {
      const timer = setTimeout(() => {
        fetchUnReceptedPatients(true, false);
      }, 500);

      setUnReceptedTimer(timer);
    }

    return () => {
      if (unreceptedTimer !== undefined) {
        clearTimeout(unreceptedTimer);
      }
    };
  }, [valueSearchBeforeReception]);

  return (
    <>
      {(receptedLoading || unreceptedLoading) && <Loader />}
      <Typography className={"styleSelectedTab"}>{moduleName}</Typography>
      {receptedPatients?.length === 0 && unReceptedPatients?.length === 0 ? (
        <Box
          height="70vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img src={qarbalNot} style={{ marginTop: "50px" }} />
        </Box>
      ) : (
        <>
          <Grid display={"flex"} flexDirection={"column"} mt={"20px"}>
            <Grid
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography>بیماران پذیرش نشده</Typography>
              <Grid display={"flex"} flexDirection={"row"}>
                <SearchInput
                  type="text"
                  id="filter-text-box-before-reception"
                  value={valueSearchBeforeReception}
                  onChange={(e) =>
                    setValueSearchBeforeReception(e.target.value)
                  }
                  mb="5px"
                  mr="20px"
                />
                {valueSearchBeforeReception.length >= 2 && (
                  <Button
                    onClick={() => {
                      setValueSearchBeforeReception("");
                      fetchUnReceptedPatients(true, true);
                    }}
                  >
                    پاک کردن فیلتر
                  </Button>
                )}
              </Grid>
            </Grid>
            <TableQarbal
              handlePatientClick={handlePatientClick}
              areaId={areaId}
              rowData={unReceptedPatients}
              moduleId={moduleId}
              totalSize={unreceptedTotalSize}
              pageable={unreceptedPageable}
              setPageable={setUnReceptedPageable}
            />
          </Grid>
          <Grid display={"flex"} flexDirection={"column"} mt={"80px"}>
            <Grid
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography mb={"10px"}>بیماران پذیرش شده</Typography>
              <Grid display={"flex"} flexDirection={"row"}>
                <SearchInput
                  type="text"
                  disabled={receptedLoading}
                  id="filter-text-box"
                  value={valueSearch}
                  onChange={(e) => setValueSearch(e.target.value)}
                  mb="5px"
                />
                {valueSearch.length >= 2 && (
                  <Button
                    onClick={() => {
                      setValueSearch("");
                      fetchReceptedPatients(true, true);
                    }}
                  >
                    پاک کردن فیلتر
                  </Button>
                )}
              </Grid>
            </Grid>
            <TableQarbal
              moduleName={moduleName}
              handlePatientClick={handlePatientClick}
              children
              isReception
              areaId={areaId}
              rowData={receptedPatients}
              moduleId={moduleId}
              totalSize={receptedTotalSize}
              pageable={receptedPageable}
              setPageable={setReceptedPageable}
            />
          </Grid>
        </>
      )}
    </>
  );
}
